import React from "react";
import PropTypes from "prop-types";
import { Show } from "@edreamsodigeo/frontend-core";
import { Box } from "@edreamsodigeo/prisma-design-system";
function CascadeComponent({
  children,
  color,
  footer,
  withBorderTop,
  fullWidth,
  position,
  top
}) {
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": "cascade",
    borderTopRightRadius: withBorderTop ? "15px" : "0px",
    borderTopLeftRadius: withBorderTop ? "15px" : "0px",
    backgroundColor: color,
    margin: fullWidth ? "minus_base" : "0px",
    position: position,
    top: top
  }, children, /*#__PURE__*/React.createElement(Show, {
    when: Boolean(footer)
  }, /*#__PURE__*/React.createElement(Box, {
    mt: !withBorderTop ? "minus_base" : "0"
  }, footer)));
}
CascadeComponent.defaultProps = {
  withBorderTop: true,
  footer: null,
  color: "",
  position: "static",
  top: "auto"
};
CascadeComponent.propTypes = {
  children: PropTypes.object.isRequired,
  color: PropTypes.string,
  footer: PropTypes.node,
  withBorderTop: PropTypes.bool,
  fullWidth: PropTypes.bool,
  position: PropTypes.string,
  top: PropTypes.string
};
export default CascadeComponent;